import { massFactor, massLabel, massOptionOf, findMassType, optionLabel } from './massCatalog';

// Prisfaktor per massetype kommer fra massekatalogen (massFactor). Bortkjøring er et tilvalg uten egen påslag.

// Bortkjøring som tilvalg (order.removal) bruker samme faktor som den gamle massetypen «removal».
export const REMOVAL_FACTOR = 1.0;

const FUEL_RATE_PER_KM = {
  diesel: 2.8, electric: 1.2, hybrid: 2.0,
};

const TOLL_ESTIMATE_KR = 45;
const FALLBACK_BASE_RATE = 20;

export function calculateBreakdown(distanceKm, massType, tons, fuelType = 'diesel', baseRate = FALLBACK_BASE_RATE, removal = false) {
  const factor          = massFactor(massType) * (removal ? REMOVAL_FACTOR : 1.0);
  const distanceBase    = Math.round(distanceKm * baseRate);
  const massSurcharge   = Math.round(distanceBase * (factor - 1.0));
  const weightSurcharge = tons > 10 ? (tons - 10) * 50 : 0;
  const toll            = TOLL_ESTIMATE_KR;
  const fuel            = Math.round(distanceKm * (FUEL_RATE_PER_KM[fuelType] ?? 2.8));
  const total           = distanceBase + massSurcharge + weightSurcharge + toll + fuel;
  return { distanceBase, massSurcharge, weightSurcharge, toll, fuel, total, distanceKm, baseRate, massType, tons, fuelType };
}

export function calculateSuggestedPrice(distanceKm, massType, tons, { removal = false } = {}) {
  const factor          = massFactor(massType) * (removal ? REMOVAL_FACTOR : 1.0);
  const basePrice       = distanceKm * FALLBACK_BASE_RATE * factor;
  const weightSurcharge = tons > 10 ? (tons - 10) * 50 : 0;
  return Math.round(basePrice + weightSurcharge);
}

export function calculateFuelCost(distanceKm, fuelType = 'diesel') {
  return Math.round(distanceKm * (FUEL_RATE_PER_KM[fuelType] ?? 2.8));
}

export function calculateTollEstimate() {
  return TOLL_ESTIMATE_KR;
}

export { FALLBACK_BASE_RATE };

// Haversine-formel — luftlinjeavstand i km (brukes til visning, ikke ruting)
export function haversineKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// Gamle faste lister. Beholdt som referanse for eldre kode og tester; aktiv visning bruker massekatalogen.
export const MASS_LABELS = {
  soil: 'Jord', gravel: 'Grus', crushed_stone: 'Pukk', sand: 'Sand', other: 'Annet', removal: 'Bortkjøring',
};

export const CRUSHED_STONE_GRADES = [
  { value: '0-4mm',   label: '0–4 mm' },
  { value: '4-8mm',   label: '4–8 mm' },
  { value: '8-16mm',  label: '8–16 mm' },
  { value: '16-22mm', label: '16–22 mm' },
  { value: '22-32mm', label: '22–32 mm' },
  { value: '32-64mm', label: '32–64 mm' },
  { value: '64mm+',   label: '64 mm+' },
];

export const SOIL_QUALITIES = [
  { value: 'clean',        label: 'Ren jord' },
  { value: 'topsoil',      label: 'Matjord' },
  { value: 'clay',         label: 'Leire' },
  { value: 'fill',         label: 'Fyllmasse' },
  { value: 'contaminated', label: 'Forurenset jord' },
];

export { massLabel };

export function getMassSubLabel(order) {
  if (order.massType === 'removal') {
    return order.requiresLoadingEquipment ? 'Sjåfør laster' : 'Lasteutstyr på stedet';
  }
  const option = massOptionOf(order);
  if (option && findMassType(order.massType)) return optionLabel(order.massType, option);
  return null;
}
